import styled, { css } from "styled-components/native";

interface Props {
	isNarrow?: any;
}

const StyledContainer = styled.View<any>`
	width: 80%;
	height: 100%;
	left: 0;
	z-index: -1;
	background-image: linear-gradient(to left, transparent, black);
	position: absolute;

	${(props) =>
		props.isNarrow &&
		css`
			width: 34.14056rem;
			height: calc(100vh - 5rem);
			flex-shrink: 0;
			background-image: linear-gradient(90deg, #000 0%, rgba(0, 0, 0, 0.95) 12.43%, rgba(0, 0, 0, 0.6) 60.51%, rgba(0, 0, 0, 0) 100%);
		`}
`;

const GradientLeftSide = (props: Props) => {
	return (
		// @ts-ignores
		<StyledContainer nativeID={"tdp-gradient-left"} isNarrow={props.isNarrow}></StyledContainer>
	);
};

export default GradientLeftSide;
